import type { OnDomLoad } from '@app/types'

import { SfLog } from '@app/adapters/logger'
import sanitizer from '@app/adapters/sanitizer'
import SchedulerAdapter from '@app/adapters/schedule'
import SFetch from '@app/utils/sfetch'

async function checkProgressRequest(
  progressUrl: string
): Promise<{ createdMessage: string } | undefined> {
  const SfAdapter = SchedulerAdapter()

  const response = await SfAdapter.promisedTimeout<
    () => Promise<{ createdMessage: string } | undefined>
  >(async function () {
    if (progressUrl) {
      try {
        const response = await SFetch.json<{ createdMessage: string }>(
          progressUrl
        )

        return { createdMessage: response?.createdMessage || '' }
      } catch (e) {
        SfLog.info('Failed polling for firm creation progress', {
          error: e,
        })

        return { createdMessage: '' }
      }
    }
  }, 2000)

  return response
}

async function checkProgress(): Promise<void> {
  const element = document.querySelector(
    "[data-behaviour='firm-creation-progress']"
  )

  if (element) {
    const progressUrl = element.getAttribute('data-progress-url')
    const response = await checkProgressRequest(progressUrl || '')

    if (response?.createdMessage) {
      created(response.createdMessage)
    } else {
      await checkProgress()
    }
  }
}

function created(message: string): void {
  const element = document.querySelector(
    "[data-behaviour='firm-creation-progress']"
  )

  if (element) {
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    const effectiveMessage = sanitizer(message).toString()

    window.requestAnimationFrame(() => {
      element.innerHTML = ''
      element.insertAdjacentHTML(
        'afterbegin',
        `
        <div class='sf-level'>
          <i class='fa fa-check sf-c-success-light-1 sf-level-item'></i>
          <div class='sf-level-item'>${effectiveMessage}</div>
        </div>
      `
      )
    })
  }
}

export default ({ onDomLoad }: { onDomLoad: OnDomLoad }): void => {
  onDomLoad(() => {
    void checkProgress()
  })
}
